var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "w-screen h-screen lg:p-10 bg-pure-white overflow-hidden" },
    [
      _c("div", { staticClass: "bl-auth-background px-4 lg:p-0" }, [
        _c(
          "div",
          { staticClass: "bl-auth-card rounded-3xl bg-pure-white p-6 lg:p-14" },
          [
            _c(
              "div",
              { staticClass: "space-y-3 mb-6 lg:w-160" },
              [
                _c("BlTextTitle4", { attrs: { text: "Change your password" } }),
                _vm._v(" "),
                _c("BlTextBody2", {
                  attrs: {
                    text:
                      "Please enter your new password to keep your personal information safe."
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _vm.verifiedTokenLoading
              ? _c(
                  "div",
                  { staticClass: "lg:w-160 h-64 grid place-items-center" },
                  [_c("div", { staticClass: "blum-loader" })]
                )
              : _c(
                  "form",
                  {
                    on: {
                      submit: function($event) {
                        $event.preventDefault()
                        return _vm.savePassword($event)
                      }
                    }
                  },
                  [
                    _c("BlInputText", {
                      staticClass: "mb-4",
                      attrs: { input: _vm.passwordInput },
                      on: { changed: _vm.inputHandler }
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "grid gap-2 lg:grid-cols-3 mb-2 lg:mb-4" },
                      [
                        _c(
                          "div",
                          { staticClass: "flex items-center gap-2" },
                          [
                            _c("BlIcon", {
                              staticClass: "rounded-full w-6 h-6",
                              class: _vm.passwordHasSixChar
                                ? "bg-success-400"
                                : _vm.passwordInputChecked
                                ? "bg-error-300 p-1"
                                : "bg-grey-300",
                              attrs: {
                                icon:
                                  _vm.passwordInputChecked &&
                                  !_vm.passwordHasSixChar
                                    ? "close"
                                    : "check",
                                color: "secondary"
                              }
                            }),
                            _vm._v(" "),
                            _c("div", { staticClass: "text-xs" }, [
                              _vm._v("6 characters minimum")
                            ])
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "flex items-center gap-2" },
                          [
                            _c("BlIcon", {
                              staticClass: "rounded-full w-6 h-6",
                              class: _vm.passwordHasUppercase
                                ? "bg-success-400"
                                : _vm.passwordInputChecked
                                ? "bg-error-300 p-1"
                                : "bg-grey-300",
                              attrs: {
                                icon:
                                  _vm.passwordInputChecked &&
                                  !_vm.passwordHasUppercase
                                    ? "close"
                                    : "check",
                                color: "secondary"
                              }
                            }),
                            _vm._v(" "),
                            _c("div", { staticClass: "text-xs" }, [
                              _vm._v("1 uppercase character")
                            ])
                          ],
                          1
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "grid gap-2 lg:grid-cols-3" }, [
                      _c(
                        "div",
                        { staticClass: "flex items-center gap-2" },
                        [
                          _c("BlIcon", {
                            staticClass: "rounded-full w-6 h-6",
                            class: _vm.passwordHasLowescase
                              ? "bg-success-400"
                              : _vm.passwordInputChecked
                              ? "bg-error-300 p-1"
                              : "bg-grey-300",
                            attrs: {
                              icon:
                                _vm.passwordInputChecked &&
                                !_vm.passwordHasLowescase
                                  ? "close"
                                  : "check",
                              color: "secondary"
                            }
                          }),
                          _vm._v(" "),
                          _c("div", { staticClass: "text-xs" }, [
                            _vm._v("1 lowercase character")
                          ])
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "flex items-center gap-2" },
                        [
                          _c("BlIcon", {
                            staticClass: "rounded-full w-6 h-6",
                            class: _vm.passwordHasNumber
                              ? "bg-success-400"
                              : _vm.passwordInputChecked
                              ? "bg-error-300 p-1"
                              : "bg-grey-300",
                            attrs: {
                              icon:
                                _vm.passwordInputChecked &&
                                !_vm.passwordHasNumber
                                  ? "close"
                                  : "check",
                              color: "secondary"
                            }
                          }),
                          _vm._v(" "),
                          _c("div", { staticClass: "text-xs" }, [
                            _vm._v("1 number")
                          ])
                        ],
                        1
                      )
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "flex items-center justify-end gap-4" },
                      [
                        _c("BlInputButton", {
                          attrs: { type: "plain", label: "Cancel" },
                          on: { clicked: _vm.goSignin }
                        }),
                        _vm._v(" "),
                        _c("BlInputButton", {
                          attrs: {
                            disabled:
                              !_vm.passwordInput.model || !_vm.verifiedToken,
                            buttonType: "submit",
                            label: "Update"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
          ]
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-05d6755a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-05d6755a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/auth/ResetPassword.vue
// module id = null
// module chunks = 